// © Microsoft Corporation. All rights reserved.

/**
 * Widget group div class name in the DOM
 */
export const widgetGroupClassName = "peregrine-widgetgroup";

/**
 * Widgets div class name in the DOM
 */
export const widgetClassName = "peregrine-widgets";

/**
 * Widget settings div
 */
export const widgetSettingsClassName = "peregrine-widget-settings";

/**
 * Widgets script core bundle class name in the DOM
 */
export const coreBundleClassName = "peregrine-core-bundle";

/**
 * Widget info attribute (used in both 'peregrine-widgetgroup' divs and 'peregrine-widgets' divs)
 */
export const widgetInfoAttribute = "data-widget";

/**
 * Widget render state attribute
 */
export const widgetRenderStateAttribute = "data-widget-state";

/**
 * Attribute name of the pcsData.info in head element
 */
export const headTagDataInfoAttribute = "data-info";

/**
  * Attribute name of the pcsData.clientSettings in head element
  */
export const  headTagtClientSettingAttribute = "data-client-settings";

/**
 * App type name of sharedWidgets app
 */
export const sharedWidgetsAppTypeName = "sharedWidgets";

/**
 * App type name of bingHomepage app
 */
export const bingHomepageAppTypeName = "bingHomepage";

/**
  * Page type of bingHomepage app
  */
export const bingHomepagePageType = "widgetfeed";

/**
  * Page name of bingHomepage app
  */
export const bingHomepagePageName = "widgetfeed";

/**
 * Ocid of bingHomepage app
 */
export const bingHomepageOcid = "BingHp01";

/**
 * Page Product of bingHomepage app
 */
export const bingHomepageProductName = "bing";

/**
 * Widget Custom Event name
 */
export const widgetCustomEventName = "PeregrineWidgetEvent";